"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)({
  root: {
    padding: 12,
    fontSize: '15px',
    '& svg': {
      width: '1em !important'
    }
  }
}, {
  name: 'IconButton'
});
exports.useStyles = useStyles;